import Store from './Store';

let loading = 0;

export default Store({
  start() {
    loading++;
    this.hasChanged();
  },

  finish() {
    loading--;
    this.hasChanged();
  },

  get() {
    return loading > 0;
  },
});
